import { useQuery } from '@tanstack/react-query';
import JsdhNotifikaceService from '../api/JsdhNotifikaceService/service/JsdhNotifikaceService';
import type { ZalohaJinde } from '../api/JsdhNotifikaceService/generated/models/ZalohaJinde';
import { BEZ_ZALOHY } from '../utils/rozdelOdpovedi';

/**
 * Lide v zaloze u jineho aktivniho poplachu, kteri u tohoto poplachu nemaji rucni odpoved.
 * Polluje stejne jako odpovedi (4 s). Bez poplachu nevola nic. Pri chybe vraci posledni
 * uspesna data, a kdyz zadna nejsou, prazdne pole — kiosk kvuli tomu nesmi spadnout.
 */
export const useZalohaJinde = (poplachId: number | undefined, deviceToken?: string): ZalohaJinde[] => {
    const { data } = useQuery<ZalohaJinde[]>({
        queryKey: ['zaloha-jinde', poplachId, deviceToken],
        queryFn: () => JsdhNotifikaceService.getZalohaJinde({ poplachId: poplachId as number, deviceToken }),
        enabled: Boolean(poplachId),
        refetchInterval: 4000,
        refetchOnWindowFocus: false,
        staleTime: 3000,
        retry: 1,
    });
    return data ?? BEZ_ZALOHY;
};
